import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('auth', ['roles', 'isAuthorizedUser']),
    ...mapGetters('featureFlag', ['allFlags']),
    ...mapGetters('httpResponse', [
      'httpText',
      'httpColor',
      'httpIsActive',
      'isProcessingActive'
    ]),
    ...mapGetters('mapping', [
      'planWhispers',
      'ratePlans',
      'templates',
      'tempPlans',
      'searchResults'
    ])
  },
  methods: {
    ...mapActions('auth', ['setRoles']),
    ...mapActions('httpResponse', [
      'setHttpResponse',
      'resetHttpResponse',
      'setProcessActive',
      'setProcessInactive'
    ]),
    ...mapActions('mapping', [
      'response',
      'loader',
      'getPlanWhispers',
      'getRatePlans',
      'getTemplates',
      'updatePlanWhisper',
      'bulkUpdatePlanWhisper',
      'changeWholesalePlan',
      'changeUtilibillPlan',
      'addTempPlan',
      'clearTempPlans',
      'searchPlans',
      'clearSearchResults',
      'setPlanSearch',
      'setPageSize'
    ])
  }
}
